import { render } from "./Motorboat.vue?vue&type=template&id=a3fc0bf0"
import script from "./Motorboat.vue?vue&type=script&lang=js"
export * from "./Motorboat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__